<template lang="html">
  <!-- <div v-show="this.settings !== undefined && this.settings.enableZoomToAds === 1" class="zoom-area-layer" :id="_uid + '-zoom-area-layer'"> -->
    <div class="zoom-area-layer" :id="_uid + '-zoom-area-layer'">

  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { setZIndexesForElements } from './CciZIndexLayers.js'

export default {
  props: ['zoomObj'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    var div = document.getElementById(this._uid + '-zoom-area-layer')
    div.removeEventListener('pageSingleClick', this.zoomAreaClicked, false)
    div.addEventListener('pageSingleClick', this.zoomAreaClicked, false)

    var box1 = this.getBox(this.zoomObj)
    var box2 = this.getBox(this.zoomObj.page)

    var x = box1.x / box2.width
    var y = box1.y / box2.height
    var width = box1.width / box2.width
    var height = box1.height / box2.height

    if (width > 1) {
      width = 1
    }

    div.style.left = x * 100 + '%'
    div.style.top = y * 100 + '%'
    div.style.width = width * 100 + '%'
    div.style.height = height * 100 + '%'

    setZIndexesForElements(document.getElementsByClassName('zoom-area-layer'), 1)
    this.applySettings(this.settings)
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      isScrolling: 'getIsScrolling',
      settings: 'getSettings',
      isFullPageViewMode: 'getPageViewMode'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined && settings.enableInteractionLayerHoverEffect) {
        var layers = document.getElementsByClassName('zoom-area-layer')
        for (var i = 0; i < layers.length; i++) {
          layers[i].classList.add("zoom-area-layer-hover")
        }
      }
    },
    zoomAreaClicked () {
      // close overlays
      if (this.$store.state.showRightAlignedNavigationBar || this.$store.state.showLeftAlignedScrubber) {
        this.$store.commit('setShowRightAlignedNavigationBar', false)
        this.$store.commit('setShowLeftAlignedScrubber', false)
        return
      }
      if (this.$store.state.showScrubber) {
        this.$store.commit('toggleScrubberVisible')
      }

      let burgerButton = document.getElementById('burger-button')
      let slider = document.getElementById('nav-right-pages')
      if (slider !== null && burgerButton !== null) {
        burgerButton.classList.remove('rotate-90-degree')
        slider.classList.remove('move-right')
      }

      const div = document.getElementById(this._uid + '-zoom-area-layer')
      if (this.settings.enableZoomToAds) {
        this.$parent.handleZoomToElement(div, this.isZoomAreaInViewport())
      } else {
        this.$store.state.selectedPageChild = this.zoomObj
        this.$store.commit('setShowArticleModal', true)
      }
    },
    getBox (obj) {
      return {
        x: parseFloat(obj.attributes.ObjectXPos),
        y: parseFloat(obj.attributes.ObjectYPos),
        width: parseFloat(obj.attributes.ObjectWidth),
        height: parseFloat(obj.attributes.ObjectHeight)
      }
    },
    getZoomObjectIfInCenter () {
      // TODO: This may be useful for some tracking
      const div = document.getElementById(this._uid + '-zoom-area-layer')
      const rect = div.getBoundingClientRect()

      const windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
      const windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight
      const centerX = windowWidth / 2
      const centerY = windowHeight / 2

      const isInCenter = (
        rect.bottom >= centerY &&
        rect.top < centerY &&
        rect.left <= centerX &&
        rect.right > centerX
      )

      if (isInCenter) return this.zoomObj
    },
    isZoomAreaInViewport () {
      const zoomAreaRect = document.getElementById(this._uid + '-zoom-area-layer').getBoundingClientRect()
      const pageWrapperRect = document.getElementById(this.$parent._uid + 'page-wrapper').getBoundingClientRect()
      return (
        zoomAreaRect.top + 50 >= pageWrapperRect.top &&
        zoomAreaRect.left + 50 >= pageWrapperRect.left &&
        zoomAreaRect.bottom - 50 <= pageWrapperRect.bottom &&
        zoomAreaRect.right - 50 <= pageWrapperRect.right
      )
    }
  }
}
</script>

<style lang=scss>
.zoom-area-layer {
  width: 100%;
  position: absolute;
  cursor: pointer;
}
.zoom-area-layer-hover {
  &:hover {
    background-color: #2980b9;
    opacity: 0.1;
  }
}
</style>
